// ===== GSTIN Validation Script =====
if (typeof $ !== 'undefined') {

// Element references
const $checkbox = $("#gstin-checkbox");
const $gstinField = $("#gstin-field");
const $gstinInput = $("#gstin-input");
const $gstinInputMiniCart = $("#gstin-input-mini-cart");
const $gstinError = $("#gstin-error");
const $gstinErrorMiniCart = $("#gstin-error-mini-cart");
const $checkoutButton = $(".t4s-btn-group__checkout-update");

// GSTIN validation regex
const gstinRegex = /^[0-9A-Z]{15}$/;

// ===== 🔍 GSTIN Validation =====
function validateGstin({ inputElement = $gstinInput, checked = null } = {}) {
  
  const id = inputElement.attr("id");
  const gstinValue = inputElement.val().trim().toUpperCase();
  inputElement.val(gstinValue);

  const isValid = gstinRegex.test(gstinValue);
  const isEmpty = gstinValue === "";
  const showError = !isValid && !isEmpty;
  const shouldValidate = checked !== null ? checked : $checkbox.is(":checked");

  // Show appropriate error field
 const inputId = inputElement.attr("id");

  // 🔍 Use ID directly to toggle correct error div
  if (inputId === "gstin-input-mini-cart") {
    $("#gstin-error-mini-cart").toggle(showError);
  } else if (inputId === "gstin-input") {
    $("#gstin-error").toggle(showError);
  }
  
  // Disable checkout if invalid
  if ($checkoutButton.length) {
    const shouldDisable = isEmpty || !isValid;
    $checkoutButton.prop("disabled", shouldDisable).css({
      opacity: shouldDisable ? "0.5" : "1",
      cursor: shouldDisable ? "not-allowed" : "pointer"
    });
  }

  return shouldValidate ? (isValid && !isEmpty) : true;
}

// ===== 🛒 Prefill on Page Load =====
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => {
    const savedGstin = cart.attributes && cart.attributes.customerGSTIN;
    if (savedGstin) {
      $checkbox.prop("checked", true);
      $gstinField.show();
      $gstinInput.val(savedGstin);
      $gstinInputMiniCart.val(savedGstin);
      validateGstin(); // validate pre-filled
    }
  })
  .catch(err => console.error("Error fetching cart:", err));

// ===== ✅ Cart Page Checkbox Handling =====
$checkbox.on("change", function () {
  if ($(this).is(":checked")) {
    $gstinField.show();
    validateGstin();
  } else {
    $gstinField.hide();
    $gstinInput.val("");
    $gstinError.hide();
    $checkoutButton.prop("disabled", false).css({
      opacity: "1",
      cursor: "pointer"
    });

    // Remove GSTIN from cart
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { customerGSTIN: "" } })
    }).then(() => console.log("GSTIN removed via checkbox uncheck"))
      .catch(err => console.error("Error clearing GSTIN:", err));
  }
});

// ===== 🔄 Cart Page Input Validation =====
$gstinInput.on("input", function () {
  validateGstin(); // uses checkbox status
});

// ===== ✅ Form Submission in Cart Page =====
const $form = $("form[action='/cart'], form[action*='checkout']");
if ($form.length) {
  $form.on("submit", function (event) {
    if ($checkbox.is(":checked")) {
      if (!validateGstin()) {
        event.preventDefault();
        return false;
      }

      const gstinValue = $gstinInput.val().trim();
      event.preventDefault(); // temporarily halt form submission

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { customerGSTIN: gstinValue }
        })
      })
      .then(res => res.json())
      .then(data => {
        console.log("GSTIN saved from cart page:", data.attributes.customerGSTIN);
        // Optionally: $form.off("submit").submit();
      })
      .catch(err => {
        console.error("Failed to update GSTIN:", err);
      });
    }
  });
}

// ===== 🧾 Mini Cart Live Input Sync =====
$(document).on("input", "#gstin-input-mini-cart", function () {
  const $input = $(this);
  const value = $input.val().trim().toUpperCase();
  $input.val(value); // force uppercase
  
  const isValid = gstinRegex.test(value);
  const isEmpty = value === "";
  console.log('isValid',isValid)
  
  validateGstin({ inputElement: $input, checked: true });

  // Save GSTIN if valid
  if (isValid) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { customerGSTIN: value }
      })
    })
    .then(res => res.json())
    .then(data => console.log("GSTIN saved from mini cart:", data.attributes.customerGSTIN))
    .catch(err => console.error("Error saving GSTIN (mini cart):", err));
  }

  // Remove GSTIN if cleared or invalid
  if (isEmpty || value.length < 15) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: { customerGSTIN: "" }
      })
    })
    .then(res => res.json())
    .then(() => console.log("GSTIN removed from mini cart"))
    .catch(err => console.error("Error removing GSTIN (mini cart):", err));
  }
});
$(document).on("click", ".t4s-site-nav__icon.t4s-site-nav__cart", function () {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => {
      const savedGstin = cart.attributes && cart.attributes.customerGSTIN;
      const $input = $("#gstin-input-mini-cart");

      if ($input.length) {
        if (savedGstin && savedGstin.trim() !== "") {
          $input.val(savedGstin.toUpperCase());
          validateGstin({ inputElement: $input, checked: true });
        } else {
          $input.val("");
          validateGstin({ inputElement: $input, checked: true });
        }
      }
    })
    .catch(err => {
      console.error("Failed to fetch cart GSTIN on cart icon click:", err);
    });
});

} // end jQuery availability check
